module.exports = __webpack_public_path__ + "static/img/1-2.b104453.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/1-2.png
// module id = 0k5Q
// module chunks = 0